<script>
import Card from '@wielink-application/shared/vue/components/card.vue'

export default Card;
</script>